import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";
// import { xsollaProducts, PAicon } from "./PAsolutionsMenu";
import { xsollaProducts } from "../data/xsollaProducts";
import { PAicon } from "./menu/PAicon";

import { vc } from "../data/vc";







import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Card,
  Dropdown,
  Pill,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import { Link } from "react-router-dom";
import PAh2 from "./PAh2";

import Tap from "react-interactions";
import "react-interactions/dist/main.css";






const useMore = [
  {
    product: 'site_builder',
    // name: 'Landing page',
    name: 'Create landing page',
    action: '/site_builder/new'
  },
  {
    product: 'launcher',
    // name: 'Launcher',
    name: 'Create new Launcher',
    action: '/game_store/new_widget'
  },
  {
    product: 'game_store',
    // name: 'Widget',
    name: 'Use widget',
    action: '/game_store/new_widget'
  },
]




export default function CardNew({
  children,
  appearance = "solid", //"flatten""transparent"
  title = "New asset",
  icon = "add",
  background = "#FFFFFF",
  wave = true,
  hover = true,
  indentation = "md",
  display = "card", //'card''table'
  style
}) {
  return (

      <CssCardNew0
        appearance={appearance}
        // className="xsui-card misha-hover"
        hover={false}
        indentation={indentation}
        style={{
          flexGrow: 1,
          width: "100%",
          cursor: !!hover ? 'pointer' : 'arrow',
          height: "100%",
          position: "relative",
          // color: '#0073f7',
          borderRadius: 2,
          // overflow: 'hidden',
          // borderRadius: indentation === "sm"
          // ? `4px`
          // : indentation === "lg"
          // ? `8px`
          // : `8px`,
          // // overflow: 'hidden',
          boxShadow:
            appearance === "solid" ? "0 1px 3px 0 rgba(0, 36, 77, 0.3)" : "0",
          border: "solid 0.5px rgba(0, 36, 77, 0.08)",
          // backgroundColor: appearance === "solid" ? background : "trasparent",
          backgroundColor: appearance === "solid" ? background : appearance === "flatten" ? "trasparent" : "trasparent",
          border:
            appearance === "transparent" ? "1px solid rgba(0,115,247,.32)" : 0,
          // display: (align) ? 'grid' : 'block',
          // placeItems: (align) ? 'center center' : 'inherit',
          ...style
        }}
      >

          {!!children && (
            <div style={{
              position: "relative",
              zIndex: 1,
              flexGrow: 1,
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'stretch',
            }}>
              {children}
            </div>
          )}

          {!children && (
            <div
              style={{
                flexGrow: 1,
                width: "100%",
                display: "flex",
                flexFlow: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
              }}
            >
              <div style={{ marginBottom: 8 }}>
                {icon === "add" && (
                  <Button
                    appearance="flatten"
                    icon={icon}
                    style={{ background: "#f7faff" }}
                  >
                    {" "}
                  </Button>
                )}

                {icon === "gamekey" && (
                  <svg
                    width={52}
                    height={52}
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.4736 11.0106H15.4795V15.0224H33.5323H34.5353H35.5382H36.5412H37.5441H38.547H39.55H40.5529V17.0282H39.55V19.0341H38.547V21.04H37.5441V23.0458H36.5412V25.0517H35.5382V27.0576H34.5353V29.0634H33.5323V31.0693H15.4795V34.0781H29.5206V36.084H15.4795H13.4736V31.0693V15.0224V13.0165H10.4648V11.0106H13.4736ZM15.4795 37.0869H19.4913V41.0987H15.4795V37.0869ZM25.5089 37.0869H29.5206V41.0987H25.5089V37.0869Z"
                      fill="#0073F7"
                    />
                  </svg>
                )}

                {icon === "login" && (
                  <svg
                    width={52}
                    height={52}
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M39.0566 9.92054H41.2078V41.1133V42.1889H20.7712V40.0377V31.4328H22.9224V40.0377H39.0566V12.0718H22.9224V18.5254H20.7712V9.92054H22.9224H39.0566ZM25.0736 17.4498H26.1492V19.601H26.687H26.1492V18.5254H27.2248V19.601H26.687H28.3005V20.6767H29.3761V21.7523H30.4517V23.9035H30.9895H30.4517V22.8279H31.5273V23.9035H30.9895H32.6029V26.0547H31.5273V27.1303H30.4517V28.2059H29.3761V29.2815H28.3005V30.3572H27.2248V31.4328H26.1492V32.5084H25.0736V33.584H23.998V32.5084V30.3572H8.93945V19.601H23.998V17.4498V16.3742H25.0736V17.4498ZM33.6785 22.8279H32.6029V21.7523H31.5273V20.6767H30.4517V19.601H29.3761V18.5254H28.3005V17.4498H27.2248V16.3742H26.1492V15.2986H23.998V13.1474H37.981V15.2986V16.3742V17.4498V18.5254V19.601V20.6767V21.7523V22.8279V24.9791V27.1303V28.2059V29.2815V30.3572V31.4328V32.5084V33.584V34.6596V38.962H23.998V34.6596H26.1492V33.584H27.2248V32.5084H28.3005V31.4328H29.3761V30.3572H30.4517V29.2815H31.5273V28.2059H32.6029V27.1303H33.6785V24.9791V22.8279Z"
                      fill="#0073F7"
                    />
                  </svg>
                )}

                {icon === "launcher" && (
                  <svg
                    width={52}
                    height={52}
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M41.1125 24.9791H42.1882V31.4328H41.1125H38.9613V22.8279H41.1125V24.9791ZM10.9955 31.4328H9.91992V24.9791H10.9955V22.8279H13.1467V31.4328H10.9955ZM35.7345 34.6596H37.8857V35.7352H14.2224V34.6596H16.3736V32.5084H35.7345V34.6596ZM22.8272 10.9962V9.92054H29.2809V10.9962H31.4321V12.0718H33.5833V13.1474H35.7345V16.3742H37.8857V20.6767H14.2224V16.3742H16.3736V13.1474H18.5248V12.0718H20.676V10.9962H22.8272ZM37.8857 21.7523V31.4328H14.2224V21.7523H37.8857ZM24.9784 36.8108H27.1296V42.1889H24.9784V36.8108ZM21.7516 36.8108H23.9028V41.1133H21.7516V36.8108ZM18.5248 36.8108H20.676V38.962H18.5248V36.8108ZM28.2053 36.8108H30.3565V41.1133H28.2053V36.8108ZM31.4321 36.8108H33.5833V38.962H31.4321V36.8108Z"
                      fill="#0073F7"
                    />
                  </svg>
                )}

                {icon === "site" && (
                  <svg
                    width={52}
                    height={52}
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.8451 13.8447H21.1708V21.1705H13.8451V13.8447ZM13.8451 22.3915H21.1708V29.7173H13.8451V22.3915ZM22.3918 13.8447H29.7176V21.1705H22.3918V13.8447ZM22.3918 22.3915H29.7176V29.7173H22.3918V22.3915ZM30.9386 13.8447H38.2643V21.1705H30.9386V13.8447ZM30.9386 22.3915H38.2643V29.7173H30.9386V22.3915ZM13.8451 30.9382H21.1708V38.264H13.8451V30.9382ZM22.3918 30.9382H29.7176V38.264H22.3918V30.9382ZM30.9386 30.9382H38.2643V38.264H30.9386V30.9382ZM7.74023 7.73991H12.6241V12.6238H7.74023V7.73991ZM7.74023 39.485H12.6241V44.3688H7.74023V39.485ZM39.4853 7.73991H44.3692V12.6238H39.4853V7.73991ZM39.4853 39.485H44.3692V44.3688H39.4853V39.485Z"
                      fill="#0073F7"
                    />
                  </svg>
                )}
              </div>

              <Button
                appearance="flatten"
                style={{ textTransform: "uppercase" }}
              >
                {title}
              </Button>
            </div>
          )}


        {!!wave && <Tap waves fade={0.1} />}
      </CssCardNew0>

  );
}


export const CssCardNew0 = styled.div`
  height: 100%;
  flex-direction: column;
  display: flex;
  flex-grow: 1;

  padding: 16px 20px 16px 20px;
  ${({indentation}) => indentation === "sm" && css`
    padding: 8px 8px 8px 8px;
  `};

  ${({indentation}) => indentation === "lg" && css`
    padding: 24px 36px 36px 36px;
  `};

  ${({appearance}) => appearance === 'flatten' ? css`
    padding-left: 0;
    padding-right: 0;
    background: transparent;
    box-shadow: none
  ` : ''}


  opacity: 1;
  transition: all 250ms ease-in-out;
  &:hover {
    ${({hover}) => typeof hover === 'undefined' ? css`opacity: 0.8;` : ''}
  }
`



export const CardFlatten = ({
  children,
  title = "New asset",
  icon = "add",
  wave = true,
  hover = true,
  ...props
}) => {
  return (
    <div
      // className="xsui-card"
      className={hover ? `misha-hover xsui-card` : `xsui-card`}
      {...props}
      style={{
        background: "#f7faff",
        width: "100%",
        color: "#0073f7",
        boxShadow: "none",
        cursor: "pointer",
        borderRadius: 8,
        border: "1px solid rgba(0,115,247,.32)"
        // display: (align) ? 'grid' : 'block',
        // placeItems: (align) ? 'center center' : 'inherit',
      }}
    >
      {children}

      {!children && (
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
          }}
        >
          <div style={{ marginBottom: 8 }}>
            {icon === "add" && (
              <Button
                appearance="flatten"
                icon={icon}
                style={{ background: "#f7faff" }}
              >
                {" "}
              </Button>
            )}

            {icon === "gamekey" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.4736 11.0106H15.4795V15.0224H33.5323H34.5353H35.5382H36.5412H37.5441H38.547H39.55H40.5529V17.0282H39.55V19.0341H38.547V21.04H37.5441V23.0458H36.5412V25.0517H35.5382V27.0576H34.5353V29.0634H33.5323V31.0693H15.4795V34.0781H29.5206V36.084H15.4795H13.4736V31.0693V15.0224V13.0165H10.4648V11.0106H13.4736ZM15.4795 37.0869H19.4913V41.0987H15.4795V37.0869ZM25.5089 37.0869H29.5206V41.0987H25.5089V37.0869Z"
                  fill="#0073F7"
                />
              </svg>
            )}

            {icon === "login" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M39.0566 9.92054H41.2078V41.1133V42.1889H20.7712V40.0377V31.4328H22.9224V40.0377H39.0566V12.0718H22.9224V18.5254H20.7712V9.92054H22.9224H39.0566ZM25.0736 17.4498H26.1492V19.601H26.687H26.1492V18.5254H27.2248V19.601H26.687H28.3005V20.6767H29.3761V21.7523H30.4517V23.9035H30.9895H30.4517V22.8279H31.5273V23.9035H30.9895H32.6029V26.0547H31.5273V27.1303H30.4517V28.2059H29.3761V29.2815H28.3005V30.3572H27.2248V31.4328H26.1492V32.5084H25.0736V33.584H23.998V32.5084V30.3572H8.93945V19.601H23.998V17.4498V16.3742H25.0736V17.4498ZM33.6785 22.8279H32.6029V21.7523H31.5273V20.6767H30.4517V19.601H29.3761V18.5254H28.3005V17.4498H27.2248V16.3742H26.1492V15.2986H23.998V13.1474H37.981V15.2986V16.3742V17.4498V18.5254V19.601V20.6767V21.7523V22.8279V24.9791V27.1303V28.2059V29.2815V30.3572V31.4328V32.5084V33.584V34.6596V38.962H23.998V34.6596H26.1492V33.584H27.2248V32.5084H28.3005V31.4328H29.3761V30.3572H30.4517V29.2815H31.5273V28.2059H32.6029V27.1303H33.6785V24.9791V22.8279Z"
                  fill="#0073F7"
                />
              </svg>
            )}

            {icon === "launcher" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M41.1125 24.9791H42.1882V31.4328H41.1125H38.9613V22.8279H41.1125V24.9791ZM10.9955 31.4328H9.91992V24.9791H10.9955V22.8279H13.1467V31.4328H10.9955ZM35.7345 34.6596H37.8857V35.7352H14.2224V34.6596H16.3736V32.5084H35.7345V34.6596ZM22.8272 10.9962V9.92054H29.2809V10.9962H31.4321V12.0718H33.5833V13.1474H35.7345V16.3742H37.8857V20.6767H14.2224V16.3742H16.3736V13.1474H18.5248V12.0718H20.676V10.9962H22.8272ZM37.8857 21.7523V31.4328H14.2224V21.7523H37.8857ZM24.9784 36.8108H27.1296V42.1889H24.9784V36.8108ZM21.7516 36.8108H23.9028V41.1133H21.7516V36.8108ZM18.5248 36.8108H20.676V38.962H18.5248V36.8108ZM28.2053 36.8108H30.3565V41.1133H28.2053V36.8108ZM31.4321 36.8108H33.5833V38.962H31.4321V36.8108Z"
                  fill="#0073F7"
                />
              </svg>
            )}

            {icon === "site" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.8451 13.8447H21.1708V21.1705H13.8451V13.8447ZM13.8451 22.3915H21.1708V29.7173H13.8451V22.3915ZM22.3918 13.8447H29.7176V21.1705H22.3918V13.8447ZM22.3918 22.3915H29.7176V29.7173H22.3918V22.3915ZM30.9386 13.8447H38.2643V21.1705H30.9386V13.8447ZM30.9386 22.3915H38.2643V29.7173H30.9386V22.3915ZM13.8451 30.9382H21.1708V38.264H13.8451V30.9382ZM22.3918 30.9382H29.7176V38.264H22.3918V30.9382ZM30.9386 30.9382H38.2643V38.264H30.9386V30.9382ZM7.74023 7.73991H12.6241V12.6238H7.74023V7.73991ZM7.74023 39.485H12.6241V44.3688H7.74023V39.485ZM39.4853 7.73991H44.3692V12.6238H39.4853V7.73991ZM39.4853 39.485H44.3692V44.3688H39.4853V39.485Z"
                  fill="#0073F7"
                />
              </svg>
            )}
          </div>

          <Button appearance="flatten" style={{ textTransform: "uppercase" }}>
            {title}
          </Button>
        </div>
      )}

      {!!wave && <Tap waves fade={0.1} />}
    </div>
  );
}







export const CardTodo = ({ todo = [] }) => {
  let count = 0;
  return todo.map((oneTodo, index) => {
    if (oneTodo.value !== 1) {
      count = count + 1;
    }
    if (todo.length) {return (
      oneTodo.value !== 1 && (
        <FormGroup
          indentation="sm"
          // style={{ opacity: count > 1 ? 0.4 : 1 }}
        >

          <div className="login-item__header2">To do:</div>

          <Link to={oneTodo["url"] ? oneTodo["url"] : "#"}>
            <div
              // className="misha-hover-link xsui-button--appearance-flatten--left"
              className="p_todo_item"
            >
              {/* <span style={{ marginRight: 16, height: 24 }}> */}
              <div className="l_flex">
                <div className="p_modal_todo_icon">
                {oneTodo.value === 0.5 && (
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.0003 21.3335C17.1549 21.3335 21.3336 17.1548 21.3336 12.0001C21.3336 6.84547 17.1549 2.6668 12.0003 2.6668C6.8456 2.6668 2.66693 6.84547 2.66693 12.0001C2.66693 17.1548 6.8456 21.3335 12.0003 21.3335Z"
                      fill="#C5D0DB"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.0410156 13C0.549167 19.1595 5.70928 24 11.9999 24C18.6274 24 23.9999 18.6274 23.9999 12C23.9999 5.37258 18.6274 0 11.9999 0V2.6668C12 2.6668 12.0001 2.6668 12.0002 2.6668C17.1549 2.6668 21.3335 6.84547 21.3335 12.0001C21.3335 17.1548 17.1549 21.3335 12.0002 21.3335C7.18333 21.3335 3.21871 17.6845 2.7198 13H0.0410156Z"
                      fill="#0073F7"
                    />
                  </svg>
                )}

                {oneTodo.value === 0 && (
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 21.3333C17.1547 21.3333 21.3333 17.1547 21.3333 12C21.3333 6.84534 17.1547 2.66667 12 2.66667C6.84534 2.66667 2.66667 6.84534 2.66667 12C2.66667 17.1547 6.84534 21.3333 12 21.3333Z"
                      fill="#C5D0DB"
                    />
                  </svg>
                )}
                </div>
              {/* </span>{" "} */}
              {oneTodo.title} →
              </div>
            </div>
          </Link>
        </FormGroup>
      )
    )} else {
      return null;
    }
  });
};

export const CardSite = ({
  to = "/site_builder/my_project",
  indentation = "lg",
  status = "draft",
  title = "My Site",
  image = "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
  urlTemp = "xsollus-game",
  url = false,
  todo = [
    // {
    //   title: "Complete setting up your landing page",
    //   value: 0.5
    // },
    // {
    //   title: "Sign Licensing Agreement",
    //   value: 0
    // },
    // {
    //   title: "Publish your landing page",
    //   value: 0
    // },
    // {
    //   title: "Set up your own domain",
    //   value: 0
    // },
    // {
    //   title: "Use Partner Network",
    //   value: 0
    // }
  ]
}) => {
  const Status = ({ status = "draft" }) => {
    let result = <div />;
    switch (status) {
      case "draft":
        result = <StatusDot status="testing">Needs attention</StatusDot>;
        break;

      case "published":
        result = <StatusDot status="enabled">Ready</StatusDot>;
        break;

      default:
        result = <StatusDot status="testing">Needs attention</StatusDot>;
        break;
    }
    return result;
  };

  return (
    <div
      style={{
        // flexGrow: 1,
        // height: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Link className="link_with_color" to={to}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: todo.length ? `140px` : `140px`,
            flexGrow: 0,
            // flexShrink: 0,
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundColor: "#00244d",
            borderRadius: "8px 8px 0 0",
            position: "relative",
            // marginBottom: -20,
            zIndex:
             0
          }}
        />

        <div
          className="xs
          ui-card-sites"
          style={{
            flexGrow: 1,
            zIndex:
             10,
            height:
            "100%"
          }}

 >
          <CardNew
            // size="sm"
            indentation={indentation}
            style={{
              height: "100%"
            }}
          >
            <FormGroup
              // border="sm"
              indentation="md"
              style={{
                height: "100%"
              }}
            >
              <FormGroup border={todo.length ? "sm" : null}>
                <FormGroup indentation="xs">
                  <Status status={status} />
                </FormGroup>

                <FormGroup
                  // label="Website URL"
                  indentation="xs"
                >
                  <div className="xsui-head__title">{title}</div>
                </FormGroup>

                <FormGroup
                  // label="Website URL"
                  indentation="xs"
                >
                  <div style={{ display: "flex" }}>
                    <span style={{ color: "black", fontSize: 14 }}>
                      Preview:&nbsp;
                    </span>
                    <span className="xsui-button--appearance-flatten--left">
                      {url ? url : `${urlTemp}`}
                      <Icon name="new-tab" />
                    </span>
                  </div>
                </FormGroup>
              </FormGroup>

              {/* <FormGroup
                  // label="Project test link"
                  indentation="sm"
                >
                  <div style={{ width: "100%" }}>
                    <Button size="sm" appearance="secondary">
                      <Icon size={20} name="edit" />
                      &nbsp;&nbsp;
                      Edit site
                    </Button>
                  </div>
                </FormGroup> */}
            </FormGroup>

            {!!todo.length && (
              <div style={{ flexGrow: 1 }}>
                <FormGroup
                // border="lg"
                >
                  <CardTodo todo={todo} />
                </FormGroup>
              </div>
            )}

            {/* <FormGroup label="History" indentation="sm">
        <div className="card-last-desc">
          <div className="card-last-desc__info">
            <div className="card-last-desc__info__title">
              Last changed by m.miroshnikov@xsolla.com
            </div>
            <div className="card-last-desc__info__date">
              02/26/19, 2:23 PM
            </div>
          </div>
          <div className="card-last-desc__info">
            <div className="card-last-desc__info__title">
              Last published by m.miroshnikov@xsolla.com
            </div>
            <div className="card-last-desc__info__date">
              03/26/19, 2:23 PM
            </div>
          </div>

        </div>
        </FormGroup> */}

            {/* <div style={{marginTop: 'auto'}}>
        <FormFooter ignoreCentered={true}>
          <Button appearance="outline-primary">Configure</Button>

          <Button appearance="icon">
            <Icon name="more" />
          </Button>

        </FormFooter>
      </div> */}
          </CardNew>
        </div>
      </Link>
    </div>
  );
};










export const CardItem = ({
  appearance,
  cardType = 'row',
  product,
  sku = 'login_1',
  customize,
  price = '$19.99',
  prices_array = [],
  name = "Login for My Game: Ultimate Edition",
  items,
  id = "ce084f8d-89bf-11e8-ad67",
  img = "",
  status = "active",
  used = [],
  todo = [],
  size= "md", //xs/sm/md/lg
  button = "Finish setup",
}) => {
  return (
    <CardNew indentation="lg" wave={false}
    appearance={appearance}
    style={{
      padding: 0,
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'stretch',
      height: "100%",
      alignSelf: 'stretch',
    }}>


      <CSScard2cols cardType={cardType}>


      <CardNew
        size={size}
        style={{padding:0}}
      appearance={appearance === 'flatten' ? 'solid' : 'flatten'}
      >
        <CSScardTop0 status={status} size={size}>

          <CssStatus right={product}>
            <Pill appearance={`${status !== 'draft' ? `active` : `info`}`} >
              {status !== 'draft' ? `Selling` : `Draft`}
            </Pill>
          </CssStatus>

          {!!product && <CSSprodIcon>
            <div style={{color: 'white'}}>
              <PAicon product={product} width="24" height="24" color="#0073f7" />
            </div>
          </CSSprodIcon>}


          {typeof img === 'string' && <CSScardLoginImage img={img} size={size} />}
          {typeof img === 'function' && <CSScardLoginImage>{img()}</CSScardLoginImage>}

          {!!customize && <CSSedit>
            <Link to={`${product}/${sku}/${customize}`}>
            <Button size={size === 'sm' ? 'sm' : 'md'} appearance="secondary">
              <Icon name="settings" /> Set up visual
            </Button>
            </Link>
          </CSSedit>}

        </CSScardTop0>
    </CardNew>



        <div
        style={{ padding: "16px 24px 16px 24px" }}
        >



            {/* <div style={{display: 'flex'}}> */}

                {/* <div style={{
                  fontSize: "13px",
                  display: "flex"
                }}>
                  <StatusDot
                      status={`${status !== 'draft' ? `enabled` : `testing`}`}
                      > {status}</StatusDot>
                </div> */}


              <FormGroup indentation="xs">
                <div className="login-item__header2">
                  {id}
                </div>
              </FormGroup>
            {/* </div> */}



            <FormGroup indentation="xs">
              <PAh2 tag="h3" wrap={true} title={name} indentation="sm" />

              <PAh2 tag="h4" wrap={true} title={price} />
            </FormGroup>



          {/*
                    <CardTodo
                      todo={todo}
                    /> */}
          {/*//TODO: туду на карточке */}


          <FormGroup indentation='md'>


              <div style={{display: 'flex',}}>

                {typeof button === 'function' && button()}

                {typeof button === 'string' && <Link to={`${product}/${sku}`}>
                  <Button
                  appearance="secondary"
                  // appearance="outline"
                  // size="sm"
                  // icon="settings"
                  >
                    {/* <Icon name="settings" /> */}
                    {button}
                  </Button>
                </Link>}


                <Dropdown
                  autosize={true}
                  // separated={true}
                  options={[
                    {
                      label: 'Edit settings',
                      // description: 'The button will start ',
                      // customIcon: <StatusDot status="enabled" />,
                      customIcon: <Icon name="edit" />,
                      iconAlign: 'right'
                    },
                    {
                      label: 'Duplicate button',
                      // description: 'The button will start ',
                      // customIcon: <StatusDot status="enabled" />,
                      customIcon: <Icon name="copy" />,
                      iconAlign: 'right'
                    },
                    {
                      label: 'Delete button',
                      // description: 'The button will start ',
                      // customIcon: <StatusDot status="enabled" />,
                      customIcon: <Icon name="delete" />,
                      iconAlign: 'right'
                    },
                  ]}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      alignItems: 'center',
                      flexGrow: 1,
                      height: '100%',
                      marginLeft: 16,
                    }}>
                      <Icon name="more" size={28} />
                    </div>
                </Dropdown>

              </div>


          </FormGroup>


          </div>



          {!!used.length && <div
          style={{ padding: "16px 24px 16px 24px" }}
          >


          <CssFormGroup2 cardType={cardType}>
            <FormGroup>
              <div className="login-item__header2">Used with:</div>

              {used.map((oneUsed, ind) => {
                return (
                  <div
                    key={`login_${ind}`}
                    style={{
                      display: "flex",
                      fontSize: 14,
                      padding: "0px 0px"
                    }}
                    // className="ui-table__body__row"
                  >

                    <UsedLine {...oneUsed} />

                  </div>
                );
              })}

              {!!items && items}

              {useMore.map((unUsed, ind)=>{


                // used.forEach(oneUsed => product !== oneUsed['product'] )
                // debugger
                // if (Object.values(used).indexOf(unUsed['product']) === -1) notUsed = true;
                let notUsed = used.filter(function(oneUsed) {
                  return oneUsed['product'] === unUsed['product'];
                });

                if (!notUsed.length) return (
                  <UnUsedLine {...unUsed} />
                )
              })}





            </FormGroup>
          </CssFormGroup2>



        </div>}



        {!!prices_array.length && <div
          style={{ padding: "16px 24px 16px 24px" }}
          >


          <CssFormGroup2 cardType={cardType}>
            <FormGroup>
              <div className="login-item__header2">Prices in other currency:</div>

              {prices_array.map((onePrice, ind) => {
                return (
                  <div
                    key={`login_${ind}`}
                    style={{
                      display: "flex",
                      fontSize: 14,
                      padding: "0px 0px"
                    }}
                    // className="ui-table__body__row"
                  >

                    {onePrice['name']} {onePrice['value']}

                  </div>
                );
              })}

              {!!items && items}


              {vc.map((oneV, ind) => {
                return (
                  <div
                    key={`login_${ind}`}
                    style={{
                      display: "flex",
                      fontSize: 14,
                      padding: "0px 0px"
                    }}
                    // className="ui-table__body__row"
                  >

                        <UnUsedLine
                            label = {`Set price in ${oneV['title']}`}
                          />


                  </div>
                );
              })}



            </FormGroup>
          </CssFormGroup2>



        </div>}


        {!used.length && !prices_array.length && <div className=""></div>}



      </CSScard2cols>
    </CardNew>
  );
};




export const UnUsedLine = ({product, name, action = '/', status, label}) => {
  return (
    <CardNew
    indentation="sm"
    appearance="flatten"
    // background="transparent"
  >
     <Link to={action}
      className="login-item__launcher-item"
      style={{
        // color: "#747e8a",
      }}
    >
      <div className="l_flex">

        <div
          style={{
            display: 'flex',
            width: '36px',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}>
          <Icon name='add' size={18} />
        </div>



       {!label && <div className="l_flex l_flex--grow">
          {name}
          {status === 'draft' && <CssExtra><StatusDot
            status={`${status !== 'draft' ? `enabled` : `testing`}`}
          /></CssExtra>}
        </div>}


       {!!label && <div className="l_flex l_flex--grow">
          {label}
        </div>}

      </div>

    </Link>

  </CardNew>

  )
}





export const UsedLine = ({product, name, action, status}) => {
  return (
    <CardNew
    indentation="sm"
    appearance="flatten"
    // background="transparent"
  >
    <Link to={action}
      className="login-item__launcher-item"
      style={{
        color: "#747e8a",
      }}
    >
      <div className="l_flex">

        <div style={{
          width: '36px',
        }}>
        <PAicon
          product={product}
          width="16"
          height="16"
        />
        </div>
        <div className="l_flex l_flex--grow">
          {name}
          {status === 'draft' && <CssExtra><StatusDot
            status={`${status !== 'draft' ? `enabled` : `testing`}`}
          /></CssExtra>}
        </div>

        {/* <div style={{ padding: "0 8px" }}>
          <Icon name="new-tab" />
        </div> */}
      </div>

    </Link>


  </CardNew>

  )
}


const CssExtra = styled.span`
  margin-left: 0.6em;
  display: flex;
  align-items: center;
`



const CSScardTop0 = styled.div`
  height: 100%;
  border-radius: 10px;
  position: relative;
  background-size: contain;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 16px 36px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  /* border-bottom-left-radius: 8px; */
  min-height: 140px;
  ${({size}) => size === 'xs' && css`
    min-height: 100px;
  `};
  ${({size}) => size === 'lg' && css`
    min-height: 200px;
  `};
  ${({size}) => size === 'xlg' && css`
    min-height: 280px;
  `};

  ${({status}) => status === 'active' ? css`
    background-color: #F6FAFF;
    background-image: url("https://res.cloudinary.com/maiik/image/upload/v1564044324/Xsolla_PA/xsolla-pattern.svg");
  ` : css`
    background-color: #FFF;
    background-image: url("https://uikit.xsolla.com/static/e822c49655db4e28b7e5e9ba13c90ac7.svg");
  ` };

`;



const CSSprodIcon = styled.div`
  position: absolute;
  left: 24px;
`;

const CSScard2cols = styled.div`
  ${({cardType}) => cardType === 'row' && css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px,1fr));
    /* grid-auto-columns: minmax(200px, 1fr); */
    grid-column-gap: 16px;
    width: 100%;
    height: 100%;
  `}
`;


const CSScardLoginImage = styled.div`
  display: flex;
  place-content: center;
  align-items: center;

  width: 100%;
  ${props => props.size === 'xs' && css`
    height: auto;
  `}
  ${props => props.size === 'md' && css`
    width: 100%;
    min-height: 100%;
    height: 140px;
  `}
  ${props => props.size === 'sm' && css`
    height: 80px;
  `}
  ${props => props.size === 'lg' && css`
    height: 220px;
  `}
  flex-grow: 1;
  background-image: url(${props => props.img});
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
`;

const CSSedit = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  /* background: #0000007a; */
  transition: opacity 150ms ease-in-out;
  opacity: 0;
  &:hover {
    opacity: 1;
  }
`;
const CssStatus = styled.div`
  position: absolute;
  display: flex;
  top: 16px;
  left: 16px;
  ${({right}) => right && css`
    left: auto;
    right: 16px;
  `};
`;




const CssFormGroup2 = styled.div`
 ${({cardType}) => cardType === 'row' && css`
    padding-left: 36px;
    border-left: 1px solid #e6e9ec;
    align-self: stretch;
    height: 100%;
  `}

  /* position: relative; */
  /* padding: 8px 0 0 0; */
  /* margin-bottom: -16px; */
  /* &:after {
    content: '';
    position: absolute;
    z-index: -1;
    background-color: #f7faff;
    top: -8px;
    bottom: -20px;
    left: -24px;
    right: -24px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  } */
`
